import { getV1CompaniesCompanyIdTelematicsFleets } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import connection from '~services/connectionModule';
import { useStores } from '~store';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

import { TelematicsFleet } from './models';

export default function useTelematicsFleets() {
  const { userStore } = useStores();
  const companyId = getEffectiveUserCompanyId(userStore);

  const getTelematicsFleets = useCallback(
    async (signal?: AbortSignal) => {
      try {
        const response = await getV1CompaniesCompanyIdTelematicsFleets({
          path: { 'company-id': companyId },
          signal,
        });
        return response.data.data.map(TelematicsFleet.parse);
      } catch (error) {
        if (signal?.aborted) {
          throw error;
        }

        connection.handleRequestError(
          error,
          t('error_messages.telematics.failed_to_fetch_fleets'),
        );
      }
    },
    [companyId],
  );

  return { getTelematicsFleets };
}
